export class TokenError extends Error {}
